/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }

  connectWooCommerce({ storeUrl, consumerKey, consumerSecret }) {
    return axios.post(`${this.baseUrl()}/integrations/woocommerce`, {
      store_url: storeUrl,
      consumer_key: consumerKey,
      consumer_secret: consumerSecret,
    });
  }

  getWooCommerceSyncStatus() {
    return axios.get(`${this.baseUrl()}/integrations/woocommerce/sync_status`);
  }

  getWooCommerceSyncHistory(limit = 20) {
    return axios.get(
      `${this.baseUrl()}/integrations/woocommerce/sync_history`,
      {
        params: { limit },
      }
    );
  }

  triggerWooCommerceSync(forceFullSync = false) {
    return axios.post(
      `${this.baseUrl()}/integrations/woocommerce/trigger_sync`,
      {
        force_full_sync: forceFullSync,
      }
    );
  }
}

export default new IntegrationsAPI();
